import * as React from "react";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Paper from '@material-ui/core/Paper';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import {createStyles, Theme, Toolbar, withStyles, WithStyles, TextField} from "@material-ui/core";
import {withTranslation, WithTranslation} from "react-i18next";
import {AnyAction, compose} from "redux";
import {OverviewAccounts} from "../../store/account/types";
import axios from "axios";
import {User} from "../../store/user/types";
import http from "http";

type IProps = WithTranslation & WithStyles & {
    account: Array<OverviewAccounts>;
    open: boolean;
    closeDialog : any;
    thunkSaveAccount: any;
}

interface IState {
    account: Array<OverviewAccounts>;
    selectedAccount: OverviewAccounts;
    open: boolean;
    errorMsg: string;
    canSave? : boolean;
}

class EditAccountDialog extends React.Component<IProps,IState>{

    state = {
        account : this.props.account,
        selectedAccount: this.props.account[0],
        open: this.props.open,
        errorMsg: '',
        canSave: false
    }

    handleChange = (name :string) => (event : React.ChangeEvent) => {
        let key: (keyof OverviewAccounts) = (name as any);
        let accountNew = this.state.selectedAccount;
        let val;
        if(key == 'enabled'){
            val = (event.target as HTMLInputElement).checked;
        } else {
            val = (event.target as HTMLInputElement).value;
        }
        accountNew[key] = val;
        this.setState({ 'selectedAccount': accountNew, canSave: true});
    };

    handleSave = (event : any) => {
        // event.preventDefault();
        let url = process.env.REACT_APP_SUPPLIER_SERVER_URL + '/accounts/' + this.props.account[0].login;
        axios.put(url, this.props.account[0])
            .then(res => {
                if (res.status == 200) {
                    console.log("saved " + res.data);
                } else {
                    console.log("Error Save")
                }
            })
            .catch(err => {
                console.log(err);
            });
        this.props.closeDialog(true);
    };

    handleClose = () => {
        this.props.closeDialog(true)
    };

    shouldComponentUpdate(nextProps: any, nextState: any) {
        if (nextProps.open != this.state.open) {
            nextState.open = nextProps.open
            nextState.selectedAccount = nextProps.account[0];
        }
        return true;
    }

    render() {
        if (!(this.props.account === null || this.props.account === undefined || this.props.open === false)) {
            const {t} = this.props;
            const selectedAccount = this.state.selectedAccount;
            return (
                <Dialog
                    open={this.props.open}
                    onClose={this.handleClose}>
                    <DialogContent>
                        <p>{this.state.errorMsg}</p>
                        <Paper style={{padding: "10px", margin: "10px"}}>
                            <table style={{margin: "10px"}}>
                                <tbody>
                                <tr>
                                    <td><InputLabel> <strong> {t('Accounts.supplierId')}</strong> </InputLabel></td>
                                    <td><input readOnly value={selectedAccount.supplierId}></input></td>
                                </tr>
                                <tr>
                                    <td><InputLabel> <strong> {t('Accounts.login')}</strong> </InputLabel></td>
                                    <td><input readOnly value={selectedAccount.login}></input></td>
                                </tr>
                                <tr>
                                    <td><InputLabel> <strong> {t('Accounts.company')}</strong> </InputLabel></td>
                                    <td><input defaultValue={selectedAccount.company}
                                               onChange={this.handleChange('company')}></input></td>
                                </tr>
                                <tr>
                                    <td><InputLabel> <strong> {t('Accounts.salutation')}</strong> </InputLabel></td>
                                    <td><input defaultValue={selectedAccount.salutation}
                                               onChange={this.handleChange('salutation')}></input></td>
                                </tr>
                                <tr>
                                    <td><InputLabel> <strong> {t('Accounts.firstName')}</strong> </InputLabel></td>
                                    <td><input defaultValue={selectedAccount.firstName}
                                               onChange={this.handleChange('firstName')}></input></td>
                                </tr>
                                <tr>
                                    <td><InputLabel> <strong> {t('Accounts.lastName')}</strong> </InputLabel></td>
                                    <td><input defaultValue={selectedAccount.lastName}
                                               onChange={this.handleChange('lastName')}></input></td>
                                </tr>
                                <tr>
                                    <td><InputLabel> <strong> {t('Accounts.street')}</strong> </InputLabel></td>
                                    <td><input defaultValue={selectedAccount.street}
                                               onChange={this.handleChange('street')}></input></td>
                                </tr>
                                <tr>
                                    <td><InputLabel> <strong> {t('Accounts.zipCode')}</strong> </InputLabel></td>
                                    <td><input defaultValue={selectedAccount.zipCode}
                                               onChange={this.handleChange('zipCode')}></input></td>
                                </tr>
                                <tr>
                                    <td><InputLabel> <strong> {t('Accounts.city')}</strong> </InputLabel></td>
                                    <td><input defaultValue={selectedAccount.city}
                                               onChange={this.handleChange('city')}></input></td>
                                </tr>
                                <tr>
                                    <td><InputLabel> <strong> {t('Accounts.email')}</strong> </InputLabel></td>
                                    <td><input width="auto" defaultValue={selectedAccount.email}
                                               onChange={this.handleChange('email')}></input></td>
                                </tr>
                                <tr>
                                    <td><InputLabel> <strong> {t('Accounts.phone')}</strong> </InputLabel></td>
                                    <td><input defaultValue={selectedAccount.phone}
                                               onChange={this.handleChange('phone')}></input></td>
                                </tr>
                                <tr>
                                    <td><InputLabel> <strong> {t('Accounts.enabled')}</strong> </InputLabel></td>
                                    <td><input type="checkbox" id="enabled" name="enabled" checked={selectedAccount.enabled === true} onChange={this.handleChange('enabled')}></input></td>

                                </tr>
                                </tbody>
                            </table>
                        </Paper>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            {this.props.t('ChangePasswordDialog.cancel')}
                        </Button>
                        <Button onClick={this.handleSave} color="primary" disabled={!this.state.canSave}>
                            {this.props.t('ChangePasswordDialog.save')}
                        </Button>
                    </DialogActions>
                </Dialog>
            );
        } else {
            return null;
        }
    }
}

const styles = ({palette, spacing}: Theme) => createStyles({
    control: {
        marginLeft: spacing.unit,
        marginRight: spacing.unit,
        width: 200
    },
    editForm: {}
});

export default compose(
    withStyles(styles),
    withTranslation('common')
)(EditAccountDialog) as any;
